/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router'
import Loadable from "react-loadable";

import sessionSelectors from 'redux/reduxStore/session';

import UnauthorizedRoutes from './UnauthorizedRoutes';

const AuthorizedRoutes = Loadable({
  loader: () => import(/* webpackChunkName: "AuthorizedRoutes" */ './AuthorizedRoutes'),
  loading: () => <div />
});

function mapStateToProps() {
  return {
    isLoggedIn: sessionSelectors.isLoggedIn(),
    requiresMfa: sessionSelectors.requiresMfa(),
  };
}

class Authentication extends React.Component {
  render() {
    const { isLoggedIn, requiresMfa } = this.props;
    const isAuthenticated = isLoggedIn && !requiresMfa;
    return (
      <Route path="/">
        {
          isAuthenticated ? <AuthorizedRoutes /> : <UnauthorizedRoutes />
        }
      </Route>
    )
  }
}

export default withRouter(connect(mapStateToProps)(Authentication));
